import { sendApplication } from "fe2/Actions/ActionApp";
import { hideDialog } from "fe2/Actions/ActionDialog";
import { connect } from "react-redux";
import { SendApplicationDialog } from "UIKit";

const mapStateToProps = (state, ownProps) => {
  return {
    clanLeveling: ownProps.clan.leveling,
    clanId: ownProps.clan.id,
    source: ownProps.source,
    isFetchingJoinClan: state.applications.isFetchingJoinClan,
    isHiddenAccount: state.currentAccount.isHiddenAccount
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClick: () => {
    dispatch(sendApplication(ownProps.clan, ownProps.source, ownProps.shouldFetchApplications)).then(() => {
      dispatch(hideDialog());
    });
  },
  onHideDialog: () => {
    dispatch(hideDialog());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SendApplicationDialog);